import React from 'react';
import styles from './styles.module.scss';
import Text from '@profile/src/Components/Text';
import { formatCurrency } from '@wolffun/system-currency';
import { getTimeSince } from '@profile/src/utils/date';
import { formatStatus, formatType } from '../../utils';
import classNames from 'classnames';

const ListItemDesktop = ({
  data
}) => {
  const renderItem = item => {
    const status = formatStatus(item.status);
    return /*#__PURE__*/React.createElement("div", {
      key: item.id.toString(),
      className: styles.item
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapValue
    }, /*#__PURE__*/React.createElement(Text, {
      numberOfLines: 1,
      className: styles.type
    }, formatType(item.type)), status && /*#__PURE__*/React.createElement(Text, {
      numberOfLines: 1,
      className: classNames(styles.status, styles[status.style])
    }, status.displayName)), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapValue
    }, /*#__PURE__*/React.createElement(Text, {
      className: styles.value
    }, formatCurrency(item.request, {
      withCurrency: true,
      trimWholeFraction: true
    })), !!item.lastModified && /*#__PURE__*/React.createElement(Text, {
      className: styles.subValue
    }, getTimeSince(new Date(item.lastModified)))), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapValue
    }, !!item.fee && /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, formatCurrency(item.fee, {
      withCurrency: true,
      trimWholeFraction: true
    }))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, data.map(renderItem));
};

export default ListItemDesktop;